import React, { useState, useEffect,useContext } from "react";
import axios from "axios";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Button from "components/CustomButtons/Button.js";
import UserService from "services/UserService";
import { site } from "variables/patrimoine.js";
import { makeStyles } from "@mui/styles";
import DateInput from "components/Input/DateInput.js";
import IntInput from "components/Input/IntInput.js";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import { getSite } from "services/ConfigServices";

import { NotificationContainer, NotificationManager } from 'react-notifications';
import 'assets/css/customNotifications.css';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: '#fff',
    display: "flex",
  },
  tabs: {
    borderRight: `1px solid rgba(0, 0, 0, 0.12)`,
  },
  tab: {
    paddingLeft: "0rem",
    marginLeft: "0rem",
    flexDirection: "column",
    textAlign: "left",
    display: "grid",
    justifyContent: "left",
    alignItems: "flex-start",
    maxWidth: "3rem",
  },
  input: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0rem 0rem",
  },
  inputTitle: {
    margin: "0.2rem 0rem 0.05rem 0.5rem",
  },
  select: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0.5rem",
  },
  switch: {
    marginLeft: "0.5rem",
  },
}));


export default function Reference(props) {
  const permis = JSON.parse(localStorage.getItem('permission')) || [];
  const realestateupdate = permis.includes("realestate_update");
  const { energy, parameters } = props;

  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = appContext;

  const [referenceyear, setReferenceyear] = useState("");
  const [referencefinalenergy, setReferencefinalenergy] = useState("");
  const [referenceprimaryenergy, setReferenceprimaryenergy] = useState("");
  const [referenceco2, setReferenceco2] = useState("");
  const [referencesubscriptioncost, setReferencesubscriptioncost] = useState("");
  const [referencetotalcost, setReferencetotalcost] = useState("");

  const handleReferenceyearChange = (event) => { setReferenceyear(event.target.value); };
  const handleReferencefinalenergyChange = (event) => { setReferencefinalenergy(event.target.value); };
  const handleReferenceprimaryenergyChange = (event) => { setReferenceprimaryenergy(event.target.value); };
  const handleReferenceco2Change = (event) => { setReferenceco2(event.target.value); };
  const handleReferencesubscriptioncostChange = (event) => { setReferencesubscriptioncost(event.target.value); };
  const handleReferencetotalcostChange = (event) => { setReferencetotalcost(event.target.value); };

  const handleEdit = async (event) => {
    axios
      .put(
        getSite(chartIdGroup, "energy." + energy + "." + parameters),
        {
          referenceyear,
          referencefinalenergy,
          referenceprimaryenergy,
          referenceco2,
          referencesubscriptioncost,
          referencetotalcost,
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          NotificationManager.success("Modifications enregistrées");
        }
        else {
          NotificationManager.error("Une erreur est survenue");
        }
      })
      .catch(() => {
        NotificationManager.error("Une erreur est survenue");
      });
  };

  useEffect(() => {
    axios
      .get(
        getSite(chartIdGroup, "energy." + energy + "." + parameters),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        setReferenceyear(res.data.detail?.energy?.[energy]?.[parameters]?.referenceyear);
        setReferencefinalenergy(res.data.detail?.energy?.[energy]?.[parameters]?.referencefinalenergy);
        setReferenceprimaryenergy(res.data.detail?.energy?.[energy]?.[parameters]?.referenceprimaryenergy);
        setReferenceco2(res.data.detail?.energy?.[energy]?.[parameters]?.referenceco2);
        setReferencesubscriptioncost(res.data.detail?.energy?.[energy]?.[parameters]?.referencesubscriptioncost);
        setReferencetotalcost(res.data.detail?.energy?.[energy]?.[parameters]?.referencetotalcost);
      });
  }, []);


  const classes = useStyles();

  return (
    <div style={{marginTop:"-15px"}}>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
        <div>
            <DateInput
              inputTitle={site.energy[energy][parameters].referenceyear}
              dateInput={referenceyear}
              handleDateInputChange={handleReferenceyearChange}
              specialType={"month"}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <IntInput
              inputTitle={site.energy[energy][parameters].referencefinalenergy}
              intInput={referencefinalenergy}
              handleIntInputChange={handleReferencefinalenergyChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <IntInput
              inputTitle={site.energy[energy][parameters].referenceprimaryenergy}
              intInput={referenceprimaryenergy}
              handleIntInputChange={handleReferenceprimaryenergyChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <IntInput
              inputTitle={site.energy[energy][parameters].referenceco2}
              intInput={referenceco2}
              handleIntInputChange={handleReferenceco2Change}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <IntInput
              inputTitle={site.energy[energy][parameters].referencesubscriptioncost}
              intInput={referencesubscriptioncost}
              handleIntInputChange={handleReferencesubscriptioncostChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <IntInput
              inputTitle={site.energy[energy][parameters].referencetotalcost}
              intInput={referencetotalcost}
              handleIntInputChange={handleReferencetotalcostChange}
              disabled={!realestateupdate}
            />
          </div>
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
        <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              marginTop: "1rem",
              marginLeft: "auto",
              marginRight: "0.2rem",
            }}
          >
            {realestateupdate ? <Button
              style={{
                color: "#FFFFFF",
                backgroundColor: "#91C73C",
                fontWeight: "normal",
                fontWeight: "bold",
                height: "40px",
                fontSize: "0.75rem",
                padding: "5px 15px",
                marginRight: "5px",
                marginBottom: "0px",
                marginTop: "0px",
                fontFamily: '"Source Sans Pro",sans-serif',
              }}
              onClick={() => {
                handleEdit();
              }}
            >
              Enregistrer
            </Button> : <></>}
          </div>
        </GridItem>
      </GridContainer>
      
    </div>
  );
}
